import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';

/* eslint-disable vue/no-mutating-props */
import _ from 'lodash';
import configCard from './config-card.vue';
import { returnOptions } from '../utils/config.js';
import MultiSelector from './multi-selector.vue';
import MultiLineText from './multi-line-text.vue';

export default {
  components: {
    configCard: configCard
  },
  props: {
    formConfig: {
      type: Object,
      required: true
    },
    schemeValue: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    configBy: {
      type: String,
      default: 'planner'
    },
    // 研发中不允许修改创意说明
    formDisabled: {
      type: Boolean,
      default: false
    },
    isShowFeatureTag: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      configByPlanner: this.configBy === 'planner',
      configByDesigner: this.configBy === 'designer',
      formValue: {
        plan_file: '',
        design_file: '',
        creative_spec: '',
        creative_spec_tips: '当创意说明存在下划线【_】关键词时，会按顺序自动解析写入特征标签，当存在多选时，用斜杠【/】分割，如果没有匹配会清空原选择项，第一个下划线之前内容为产品名字，不做标签识别',
        estimated_time: '',
        meta_cl: '',
        meta_pl: '',
        install_return_action: '',
        install_return_action_label: ''
      },
      title: this.configBy === 'planner' ? '策划案' : '美术资源'
    };
  },

  computed: {
    formItemList: function formItemList() {
      // 设计项目+交互素材才有垂类/品类
      var metaInfoFormItem = [];
      if (this.schemeValue.demand.category === 'design' && this.schemeValue.demand.type === 1) {
        metaInfoFormItem = [{
          visible: this.configByDesigner,
          label: '垂类：',
          type: this.readOnly ? 'plain-text' : 'input',
          prop: 'meta_cl',
          rules: [{
            required: !this.readOnly,
            message: '请配置垂类',
            trigger: 'blur'
          }]
        }, {
          visible: this.configByDesigner,
          label: '品类：',
          type: this.readOnly ? 'plain-text' : 'input',
          prop: 'meta_pl',
          rules: [{
            required: !this.readOnly,
            message: '请配置品类',
            trigger: 'blur'
          }]
        }];
      }

      // 当 formDisabled 或者 readOnly 时，都不允许编辑创意说明
      var creativeSpec = [{
        visible: this.configByDesigner,
        label: '创意说明：',
        type: 'input',
        prop: 'creative_spec',
        subtype: 'textarea',
        rules: [{
          required: true,
          message: '请配置创意说明',
          trigger: 'blur'
        }],
        params: {
          autosize: {
            minRows: 2,
            maxRows: 6
          }
        }
      }];
      if (this.readOnly || this.formDisabled) {
        creativeSpec = [{
          visible: this.configByDesigner,
          label: '创意说明：',
          type: 'plain-text',
          prop: 'creative_spec'
        }];
      }

      // 当允许存在创意标签，并且允许编辑时，增加 tips
      var creativeSpecTips = [];
      if (!this.readOnly && !this.formDisabled && this.isShowFeatureTag) {
        creativeSpecTips = [{
          visible: this.configByDesigner,
          label: '自动解析规则：',
          type: 'plain-text',
          prop: 'creative_spec_tips'
        }];
      }

      if (this.readOnly) {
        return [{
          visible: this.configByPlanner,
          label: '策划案：',
          type: 'link',
          prop: 'plan_file',
          params: {
            target: '_blank'
          }
        }, {
          visible: this.configByPlanner,
          label: '安装后返回机制：',
          component: MultiLineText,
          prop: 'install_return_action_label'
        }, {
          visible: this.configByDesigner,
          label: '美术资源案：',
          type: 'link',
          prop: 'design_file',
          params: {
            target: '_blank'
          }
        }].concat(_toConsumableArray(creativeSpec), _toConsumableArray(metaInfoFormItem));
      }

      return [{
        visible: this.configByPlanner,
        label: '上传策划案：',
        type: 'input',
        subtype: 'textarea',
        prop: 'plan_file',
        params: function params() {
          return {
            disabled: false,
            drag: true,
            'with-credentials': true,
            accept: 'application/zip,application/x-zip,application/x-zip-compressed,application/octet-stream',
            data: {
              mod: 'demand',
              allow_types: 'zip'
            },
            tip: '仅支持上传zip文件，文件必须少于100M',
            fileList: []
          };
        }
      }, {
        visible: this.configByPlanner,
        label: '计划完成日期：',
        prop: 'estimated_time',
        type: 'date-picker',
        subtype: 'date',
        params: {
          clearable: true,
          pickerOptions: {},
          placeholder: '选择日期'
        }
      }, {
        visible: this.configByPlanner,
        label: '安装后返回机制：',
        prop: 'install_return_action',
        class: 'install_return_action',
        component: MultiSelector,
        params: {
          clearable: true,
          options: returnOptions
        }
      }, {
        visible: this.configByDesigner,
        label: '上传美术资源：',
        type: 'business',
        subtype: 'single-file-uploader',
        prop: 'design_file',
        params: function params() {
          return {
            disabled: false,
            drag: true,
            'with-credentials': true,
            accept: 'application/zip,application/x-zip,application/x-zip-compressed,application/octet-stream',
            data: {
              mod: 'demand',
              allow_types: 'zip'
            },
            tip: '仅支持上传zip文件，文件必须少于100M',
            fileList: []
          };
        }
      }].concat(_toConsumableArray(creativeSpec), _toConsumableArray(creativeSpecTips), _toConsumableArray(metaInfoFormItem));
    }
  },
  watch: {
    'formValue.plan_file': function formValuePlan_file(val) {
      if (val) {
        this.schemeValue.plan_attachment = val;
      }
    },
    'formValue.design_file': function formValueDesign_file(val) {
      if (val) {
        this.schemeValue.design_attachment = val;
      }
    },
    'formValue.install_return_action': function formValueInstall_return_action(val) {
      if (val) {
        this.schemeValue.install_return_action = val;
      }
    },
    'formValue.estimated_time': function formValueEstimated_time(val) {
      if (val) {
        this.schemeValue.estimated_time = val;
      }
    },
    'formValue.creative_spec': function formValueCreative_spec(val) {
      this.schemeValue.creative_spec = val;
      this.updateFetureTagBySpec(val);
    },
    'formValue.meta_cl': function formValueMeta_cl(val) {
      this.schemeValue.meta_cl = val;
    },
    'formValue.meta_pl': function formValueMeta_pl(val) {
      this.schemeValue.meta_pl = val;
    },
    'schemeValue.fetch_data': function schemeValueFetch_data(val) {
      if (val) {
        this.fillForm();
      }
    }
  },
  methods: {
    validate: function validate(cb) {
      return this.$refs.form.validate(cb);
    },
    fillForm: function fillForm() {
      var getActionLabel = function getActionLabel(val) {
        var actions = val.split(',');
        var list = [];
        actions.forEach(function (el, index) {
          var temp = returnOptions.filter(function (item) {
            return item.value === el;
          });
          if (temp.length) {
            list.push('\u5B89\u88C5\u70B9' + (index + 1) + '\uFF1A' + temp[0].label);
          }
        });
        return list;
      };
      this.formValue.plan_file = this.schemeValue.plan_attachment || '';
      this.formValue.design_file = this.schemeValue.design_attachment || '';
      this.formValue.creative_spec = this.schemeValue.creative_spec || '';
      this.formValue.estimated_time = _.get(this.schemeValue, 'estimated_time') || '';
      this.formValue.install_return_action = _.get(this.schemeValue, 'install_return_action') || '';
      this.formValue.install_return_action_label = getActionLabel(_.get(this.schemeValue, 'install_return_action') || '');
      this.formValue.meta_pl = _.get(this.schemeValue, 'demand.meta_pl') || '';
      this.formValue.meta_cl = _.get(this.schemeValue, 'demand.meta_cl') || '';
    },
    updateFetureTagBySpec: function updateFetureTagBySpec(val) {
      if (!this.isShowFeatureTag || val.indexOf('_') === -1) return;
      var tagArray = val.split('_');
      tagArray.splice(0, 1);
      this.$emit('update-feture-tag-by-spec', tagArray);
    }
  },
  mounted: function mounted() {
    this.fillForm();
  }
};